import { Box } from '@mui/material';
import { brand } from 'src/shared/branding/brand';

export const SupportFooter = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: '32px 16px',
        color: '#757575',
        fontSize: '13px',
        lineHeight: '1.5',
      }}
    >
      Questions? Reach out to{' '}
      <a
        href={`mailto:${brand.supportEmail}`}
        style={{
          color: '#5B5FED',
          textDecoration: 'none',
          fontWeight: 500,
        }}
      >
        our support team
      </a>
    </Box>
  );
};
